import React from "react";
import {Field, reduxForm} from 'redux-form'
import {Button} from "react-bootstrap";
import styles from "./Styles.module.css";

const UserSearchForm = (props) => {
    const {handleSubmit, onFormSubmit} = props

    return (
        <form onSubmit = {handleSubmit(onFormSubmit)} >
            <Field className={`searchInput ${styles["searchUser"]}`}
                name = "username"
                component = "input"
                type = "text"
                placeholder="Search User"
            />

            <Button className="btn btn-success pull-right" type="submit">
                Search User
            </Button>
        </form>
    )
}



const UserSearch = reduxForm({
    form: 'searchUser'
})(UserSearchForm)

export default UserSearch;